import { Injectable } from '@angular/core';
import { GwcApiInstitutionsService } from '@src/app/services/gwc-api/institutions.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, first, switchMap, map } from 'rxjs/operators';
import { Institution } from '@src/app/types/gwc-api/institution.types';
import { Graduation } from '@src/app/types/gwc-api/graduation.types';
import { InstitutionQualification } from '@src/app/types/gwc-api/institution-qualification.types';
import { GraduationOrdersPaganation, InstitutionQualificationPagination } from './institution.types';
import { GwcApiInstitutionQualificationService } from '@src/app/services/gwc-api/institution-qualification.service';
import { InstitutionQualificationRegalia } from '@src/app/types/gwc-api/institution-qualification-regalia.types';
import { relativeTimeThreshold } from 'moment';
import { GwcApiListsService } from '@src/app/services/gwc-api/lists.service';
import { ListRegaliaCat } from '@src/app/types/gwc-api/list_regalia_cat.types';
import { ListRegaliaSubCat } from '@src/app/types/gwc-api/list_regalia_sub_cat.types';
import { Regalia } from '@src/app/types/gwc-api/regalia.types';
import { GwcApiRegaliaService } from '@src/app/services/gwc-api/regalia.service';
import { GwcApiInstitutionQualificationRegaliaService } from '@src/app/services/gwc-api/institution-qualification-regalia.service';
import { GwcApiGraduationsService } from '@src/app/services/gwc-api/graduations.service';
import { GwcApiOrdersService } from '@src/app/services/gwc-api/orders.service';
import { Order } from '@src/app/types/gwc-api/order.types';
import { GwcApiCeremoniesService } from '@src/app/services/gwc-api/ceremonies.service';
import { Ceremony } from '@src/app/types/gwc-api/ceremony.types';
import { ActivatedRoute } from '@angular/router';
import { GraduationAlertRegenerationRequest, GraduationAlertRegenerationResponse, GraduationAlertsResponse, GraduationAlertStatus } from '@src/app/types/gwc-api/alert.types';

@Injectable({
  providedIn: 'root'
})
export class InstitutionService {


	private _list_regalia_cats: BehaviorSubject<ListRegaliaCat[] | null> = new BehaviorSubject(null)

	private _list_regalia_sub_cats: BehaviorSubject<ListRegaliaSubCat[] | null> = new BehaviorSubject(null)

	private _regalia: BehaviorSubject<Regalia[] | null> = new BehaviorSubject(null);

	private _institution: BehaviorSubject<Institution | null> = new BehaviorSubject(null);

	private _graduations: BehaviorSubject<Graduation[] | null> = new BehaviorSubject(null);

	private _graduationsCeremonies: BehaviorSubject<Graduation[] | null> = new BehaviorSubject(null);

	private _ceremony: BehaviorSubject<Ceremony | null> = new BehaviorSubject(null);

	private _graduationOrders: BehaviorSubject<Order[] | null> = new BehaviorSubject(null);

	private _order: BehaviorSubject<Order | null> = new BehaviorSubject(null);

	private _graduationOrdersPagination: BehaviorSubject<GraduationOrdersPaganation | null> = new BehaviorSubject(null);

	private _ordersPlacedGraduations: BehaviorSubject<Graduation[] | null> = new BehaviorSubject(null)

	private _institutionQualifications: BehaviorSubject<InstitutionQualification[] | null> = new BehaviorSubject(null)

	private _institutionQualificationRegalia: BehaviorSubject<InstitutionQualificationRegalia[] | null> = new BehaviorSubject(null);

    private _institutionQualificationPagination: BehaviorSubject<InstitutionQualificationPagination | null> = new BehaviorSubject(null)

	private _institutionQualificationSearchTerm: BehaviorSubject<string> = new BehaviorSubject('')

	private _orderQueryParams: BehaviorSubject<any> = new BehaviorSubject(null)

	constructor(
		private _gwcApiListsService: GwcApiListsService,
		private _gwcApiRegaliaService: GwcApiRegaliaService,
		private _gwcApiOrdersService: GwcApiOrdersService,
		private _gwcApiInstitutionsService: GwcApiInstitutionsService,
		private _gwcApiGraduationsService: GwcApiGraduationsService,
		private _gwcApiCeremoniesServices: GwcApiCeremoniesService,
		private _gwcApiInstitutionQualificationService: GwcApiInstitutionQualificationService,
		private _gwcApiInstitutionQualificationRegaliaService: GwcApiInstitutionQualificationRegaliaService
	) { 

	}



	get listRegaliaCats() {
		return this._list_regalia_cats.asObservable()
	}

	get listRegaliaSubCats() {
		return this._list_regalia_sub_cats.asObservable()
	}

	get regalia() {
		return this._regalia.asObservable()
	}

	get institution$() {
		return this._institution.asObservable()
	}

	get graduations$() {
		return this._graduations.asObservable()
	}

	get graduationsCeremonies$() {
		return this._graduationsCeremonies.asObservable();
	}

	get ceremony$() {
		return this._ceremony.asObservable()
	}

	get graduationOrders$() {
		return this._graduationOrders.asObservable()
	}

	get order$(): Observable<Order>  {
		return this._order.asObservable();
	}

	get graduationOrdersPagination$() {
		return this._graduationOrdersPagination.asObservable()
	}

	get ordersPlacedGraduations$() {
		return this._ordersPlacedGraduations.asObservable()
	}

	get institutionQualifications$() {
		return this._institutionQualifications.asObservable()
	}

	get institutionQualificationPagination$() {
		return this._institutionQualificationPagination.asObservable()
	}

	get institutionQualificationSearchTerm(): string {
		return this._institutionQualificationSearchTerm.value
	}

	setInstitutionQualificationSearchTerm(term: string): void {
		this._institutionQualificationSearchTerm.next(term)
	}

	get institutionQualificationRegalia$() {
		return this._institutionQualificationRegalia.asObservable()
	}

	get orderQueryParams$() {
		return this._orderQueryParams.asObservable()
	}

	get currentOrderQueryParams() {
		return this._orderQueryParams.value
	}



	setOrder(order: Order | null) {
		this._order.next(order);
	}

	setOrderQueryParams(params: any): void {
		this._orderQueryParams.next(params)
	}

	setCeremony(value: Ceremony | null) {
		this._ceremony.next(value)
	}

	setInstitutionQualificationRegalia(value: InstitutionQualificationRegalia[] | null) {
		this._institutionQualificationRegalia.next(value);
	}

	getListRegaliaCat() {
		return this._gwcApiListsService.getListRegaliaCat().pipe(
			tap(regalia_cats => {
				this._list_regalia_cats.next(regalia_cats)
			})
		)
	}

	getListRegaliaSubCats() {
		return this._gwcApiListsService.getListRegaliaSubCat().pipe(
			tap(regalia_sub_cats => {
				this._list_regalia_sub_cats.next(regalia_sub_cats)
			})
		)
	}

	getRegalia(list_regalia_cat_id?: string, list_regalia_sub_cat_id?: string): Observable<Regalia[]> {
		return this._gwcApiRegaliaService.getRegalia(list_regalia_cat_id, list_regalia_sub_cat_id).pipe(
			tap(regalia => {
				this._regalia.next(regalia)
			})
		)
	}


	getInstitution(institution_id: string): Observable<Institution> {
		return this._gwcApiInstitutionsService.getInstitution(institution_id).pipe(
			tap(institution => {
				this._institution.next(institution);
			})
		)
	}


	getInstitutionGraduations(institution_id: string, queryParams?: { [key: string]: string }): Observable<Graduation[]> {
		return this._gwcApiInstitutionsService.getGraduations(institution_id, queryParams).pipe(
			tap(graduations => {
				this._graduations.next(graduations)
			}) 
		)
	}

	getInstitutionGraduationsCeremonies(institution_id): Observable<Graduation[]> {
		return this._gwcApiInstitutionsService.getGraduationsCeremonies(institution_id).pipe(
			tap(graduations => {
				this._graduationsCeremonies.next(graduations)
			})
		)
	}

	getCeremony(ceremony_id: string): Observable<Ceremony> {
		return this._gwcApiCeremoniesServices.getCeremony(ceremony_id).pipe(
			tap(ceremony => {
				this._ceremony.next(ceremony)
			})
		)
	}


	getInstitutionGraduationOrders(graduation_id: string, page: number = 0, size: number = 15, sort: string = 'created_at', order: 'asc' | 'desc' = 'desc', search: string = '', filters?, check_optional_reg?: boolean, filter_by_ineligible?: boolean, regalia_id?: string, show_no_regalia?: boolean): Observable<Order[]> {

		const pagination = { page, size, length: 0 } as GraduationOrdersPaganation;

		console.log('Fetching orders with params:', { graduation_id, page, size, sort, order, search, filters, check_optional_reg, filter_by_ineligible, regalia_id, show_no_regalia });

		return this._gwcApiGraduationsService.getOrders(graduation_id, {
			page: page + 1,
			size: '' + size,
			sort,
			order,
			search,
			order_status: filters?.order_status || '',
			check_optional_reg: check_optional_reg,
			filter_by_ineligible: filter_by_ineligible,
			regalia_id: regalia_id ?? '',
			show_no_regalia: show_no_regalia,
		}).pipe(
			tap((graduationOrders: any) => {
				console.log(graduationOrders)

				this._orderQueryParams.next({
					search: search,
					filters: filters,
					check_optional_reg: check_optional_reg,
					filter_by_ineligible: filter_by_ineligible,
						regalia_id: regalia_id,
						regalia_search: regalia_id,
						show_no_regalia: show_no_regalia,
				})

				pagination.length = graduationOrders.total;

				this._graduationOrdersPagination.next(pagination);
				this._graduationOrders.next(graduationOrders.data)
			})
		)
	}

	/**
	 * 
	 * @param order_id 
	 * @returns Observable
	 */
	getOrderDetails(order_id: string): Observable<Order> {
		return this._gwcApiOrdersService.getOrder(order_id).pipe(
			tap(order => {
				console.log(order)
				this._order.next(order)
			})
		)
	}


	getInstitutionOrdersPlacedGraduations(institution_id: string): Observable<Graduation[]> {
		return this._gwcApiInstitutionsService.getGraduations(institution_id).pipe(
			tap(ordersPlacedGraduations => {
				this._ordersPlacedGraduations.next(ordersPlacedGraduations)
			})
		)
	}


	getInstitutionQualifications(institution_id: string, page: number = 0, size: number = 100, sort: string = 'qualification', order: 'asc' | 'desc' = 'asc', search: string = ''): Observable<{ pagination: InstitutionQualificationPagination, qualifications: InstitutionQualification[]}> {

		const pagination = { page, size, length: 0 } as InstitutionQualificationPagination
		
		return this._gwcApiInstitutionsService.getQualifications(institution_id, {
			page: page + 1,
			size: '' + size,
			sort,
			order,
			search
		}).pipe(
			tap(qualifications => {

				console.log(qualifications);

				pagination.length = qualifications.total;

				this._institutionQualificationPagination.next(pagination);
				this._institutionQualifications.next(qualifications.data)
			}),
			map(qualifications => ({
				pagination,
				qualifications: qualifications.data || []
			}))
		)
	}

	deleteInstitutionQualification(institution_qualification_id: string) {
		return this._gwcApiInstitutionQualificationService.deleteInstitutionQualification(institution_qualification_id)
	}


	getInstitutionQualificationRegalia(institution_qualification_id: string): Observable<InstitutionQualificationRegalia[]> {
		return this._gwcApiInstitutionQualificationService.getinstitutionQualificationRegalia(institution_qualification_id).pipe(
			tap(regalia => {
				console.log(regalia)
				this._institutionQualificationRegalia.next(regalia);
			})
		)
	}

	getInstitutionQualificationRegaliaItem(institution_qualification_regalia_id: string): Observable<InstitutionQualificationRegalia> {
		return this._gwcApiInstitutionQualificationService.getInstitutionQualificationRegaliaItem(institution_qualification_regalia_id)
	}


	deleteInstitutionQualificationRegalia(institution_qualification_regalia_id: string) {
		return this._gwcApiInstitutionQualificationRegaliaService.deleteInstitutionQualificationRegalia(institution_qualification_regalia_id);
	}


	resetInstitutionQualificationRegalia() {
		this._institutionQualificationRegalia.next(null)
	}

	resetCeremony() {
		this._ceremony.next(null)
	}

	public downloadRFIDExport(graduation_id: string) {
		return this._gwcApiGraduationsService.rfidExport(graduation_id)
	}

	getGraduationDashboard(graduation_id: string, options: {mainCeremonyIds: string[], additionalCeremonyIds: string[]}): Observable<any> {
		
		return this._gwcApiInstitutionsService.getGraduationDashboard(graduation_id, options)
	}

	generatePickUpEmails(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.generatePickUpEmails(graduation_id)
	}

	generateBulkPickUpEmails(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.generateBulkPickUpEmails(graduation_id)
	}

	getBulkPickupEmailPreviewCandidates(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.getBulkPickupEmailPreviewCandidates(graduation_id)
	}

	previewBulkPickupEmail(graduation_id: string, bulk_individual_order_line_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.previewBulkPickupEmail(graduation_id, bulk_individual_order_line_id)
	}

	sendBulkPickupEmailTest(graduation_id: string, bulk_individual_order_line_id: string, email: string): Observable<any> {
		return this._gwcApiInstitutionsService.sendBulkPickupEmailTest(graduation_id, bulk_individual_order_line_id, email)
	}

	getPickupEmailPreviewCandidates(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.getPickupEmailPreviewCandidates(graduation_id)
	}

	previewPickupEmail(graduation_id: string, individual_order_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.previewPickupEmail(graduation_id, individual_order_id)
	}

	sendPickupEmailTest(graduation_id: string, individual_order_id: string, email: string): Observable<any> {
		return this._gwcApiInstitutionsService.sendPickupEmailTest(graduation_id, individual_order_id, email)
	}

	sendPickupEmailBatch(graduation_id: string, limit: number = 10): Observable<any> {
		return this._gwcApiInstitutionsService.sendPickupEmailBatch(graduation_id, limit)
	}

	sendBulkPickupEmailBatch(graduation_id: string, limit: number = 10): Observable<any> {
		return this._gwcApiInstitutionsService.sendBulkPickupEmailBatch(graduation_id, limit)
	}

	getNotificationStats(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.getNotificationStats(graduation_id)
	}

	exportOrdersToCSV(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.exportOrdersToCSV(graduation_id);
	}

	getGraduation(graduation_id: string): Observable<Graduation> {
		return this._gwcApiGraduationsService.getGraduation(graduation_id).pipe(
			tap(graduation => {
				this._graduations.next([graduation])
			})
		)
	}

	getGraduationAlerts(graduation_id: string, params?: {
		page?: number;
		size?: number;
		search?: string;
		type?: string;
		severity?: string;
		status?: string;
	}): Observable<GraduationAlertsResponse> {
		return this._gwcApiGraduationsService.getAlerts(graduation_id, {
			page: (params?.page ?? 0) + 1,
			size: '' + (params?.size ?? 25),
			search: params?.search ?? '',
			type: params?.type ?? '',
			severity: params?.severity ?? '',
			status: params?.status ?? '',
		});
	}

	regenerateGraduationAlerts(graduation_id: string, payload?: GraduationAlertRegenerationRequest): Observable<GraduationAlertRegenerationResponse> {
		return this._gwcApiGraduationsService.regenerateAlerts(graduation_id, payload);
	}

	updateGraduationAlertStatus(graduation_id: string, alert_id: string, status: GraduationAlertStatus): Observable<any> {
		return this._gwcApiGraduationsService.updateAlertStatus(graduation_id, alert_id, status);
	}

	openStudentLink(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.openStudentLink(graduation_id)
	}

	closeStudentLink(graduation_id: string): Observable<any> {
		return this._gwcApiInstitutionsService.closeStudentLink(graduation_id)
	}

	// sendEmails(graduation_id: string): Observable<any> {
	// 	return this._gwcApiInstitutionsService.sendEmails(graduation_id);
	// }







	// getQualifications(page: number = 0, size: number = 25, sort: string = 'qualification', order: 'asc' | 'desc' = 'asc', search: string = ''): Observable<{pagination: QualificationPagination; qualifications: Qualification[]}> {
        
    //     const pagination = { page, size, length: 0 } as QualificationPagination;

    //     return this._gwcApiQualificationsService.getQualifications({
    //         page: page + 1,
    //         size: '' + size,
    //         sort,
    //         order,
    //         search
    //     }).pipe(
    //         tap((response: any) => {

    //             pagination.length = response.total;

    //             this._pagination.next(pagination)
    //             this._qualifications.next(response.data)

    //         })
    //     )
    // }








	// private _institutions: BehaviorSubject<any> = new BehaviorSubject(null);


	// constructor(
	// 	private _gwcApiInstitutionsService: GwcApiInstitutionsService
	// ) { }


	// get institutions$() {
	// 	return this._institutions.asObservable()
	// }




	// getInstitutions() {

	// 	return this._gwcApiInstitutionsService.getInstitutions().pipe(
	// 		tap((response: any) => {
	// 			console.log(response)

	// 			this._institutions.next(response)
	// 		})
	// 	)

	// }


}
